import { Navigate } from 'react-router-dom'
import { useUser } from '../../hooks/useUser'

const AuthGuard: React.FC = (props) => {
  const user = useUser()

  if (!user.data) return <Navigate to="/auth/login" />

  return <>{props.children}</>
}

export default AuthGuard
